import * as React from 'react'

export const AccountProfileFormContext = React.createContext({})
